import { message } from "antd";
import { useCallback, useRef, useState } from "react";

export function useCopySession() {
  const [copiedId, setCopiedId] = useState<string | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const copySession = useCallback(async (sessionId: string, text: string) => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const el = document.createElement("textarea");
        el.value = text;
        el.style.cssText = "position:fixed;left:-9999px;top:-9999px";
        document.body.appendChild(el);
        el.select();
        const ok = document.execCommand("copy");
        document.body.removeChild(el);
        if (!ok) throw new Error("execCommand failed");
      }
      if (timerRef.current) clearTimeout(timerRef.current);
      setCopiedId(sessionId);
      timerRef.current = setTimeout(() => setCopiedId(null), 2000);
    } catch {
      message.error("Copy failed");
    }
  }, []);

  return { copiedId, copySession };
}
